<template>
    <section id="portfolio"
             class="w-full max-h-screen h-screen snap-start space-y-12 bg-black carousel-wrapper flex flex-col justify-center items-center">
        <h6 class="text-3xl md:text-5xl text-purple-600">Galerie</h6>
        <div class="container px-5 py-2 mx-auto lg:pt-12 lg:px-32 ">
            <div class="flex flex-wrap -m-1 md:-m-2 md:flex-row flex-col">

                <div class="flex flex-wrap lg:w-1/3 md:w-1/3">
                    <div class="w-full p-1 md:p-2">
                        <div class="relative">
                            <img alt="gallery" class="block object-cover object-center w-full h-full rounded-lg"
                                 src="https://lh3.googleusercontent.com/pw/AM-JKLUYlZfXz-UlK3uLxlMV478CHg8AcSSug1bVk9SRkufX41lbzfomaHHY0IKCnglIDoc0nyU5tC_V79Q1mmIWBenJk5XqpScCSHbINCaVVZMTYd0VGvwtgMex-eLIJwlwyyFJNr1e34cd71DFw9FegN0Q=w1742-h892-no?authuser=0">
                            <a href="https://seaweb.netlify.app/" target="_blank">
                                <div class="opacity-0 hover:opacity-100 duration-300 absolute inset-0 z-10 flex justify-center items-center text-6xl text-purple-400 font-semibold underline ">Seaweb</div>
                            </a>
                        </div>
                    </div>
                </div>

                <div class="flex flex-wrap lg:w-1/3 md:w-1/3">
                    <div class="w-full p-1 md:p-2">
                        <div class="relative">
                            <img alt="gallery" class="block object-cover object-center w-full h-full rounded-lg"
                                 src="https://lh3.googleusercontent.com/pw/AM-JKLU1x9LQzn4w_Tavo_tMcc9weLleKFB6JOIWwh8dZNUfDrKdAzZh0F3jlbCo5lSBPycaz7LkjRjAeBLdmgXimKRJrfN_ZtMz3mjOtd1p03JRTkw-QTCP0vjk87rxuGBm3eeXfi7f98WSlsz1ceK_Y85N=w1761-h892-no?authuser=0">
                            <a href="https://github.com/BenjaminAho-nienne/Freak-Boutik" target="_blank">
                                <div class="opacity-0 hover:opacity-100 duration-300 absolute inset-0 z-10 flex justify-center items-center text-6xl text-purple-400 font-semibold underline ">Freak-Boutik</div>
                            </a>
                        </div>
                    </div>
                </div>

                <div class="flex flex-wrap lg:w-1/3 md:w-1/3">
                    <div class="w-full p-1 md:p-2">
                        <div class="relative">
                            <img alt="gallery" class="block object-cover object-center w-full h-full rounded-lg"
                                 src="https://lh3.googleusercontent.com/pw/AM-JKLUlObWyyn2hkb-OD-TvbaAzl5HhdoM_2H_mmwlUyBHYFM09tc9ZomNUxADCOoM6SW30I3mt1u9yo4ph5Rh317KqRBFeMVJTempbTfXqUn-nlTpaP9MVM9iUtNuctoxUuBKlxA6d-3bsHOEfWdjjQxPe=w1749-h892-no?authuser=0">
                            <a href="https://benjaminaho-nienne.github.io/Portfolio/" target="_blank">
                                <div class="opacity-0 hover:opacity-100 duration-300 absolute inset-0 z-10 flex justify-center items-center text-6xl text-purple-400 font-semibold underline ">Old Portfolio</div>
                            </a>
                        </div>
                    </div>
                </div>



            </div>
        </div>
    </section>
<!--    <section id="portfolio"-->
<!--             class="w-full max-h-screen h-screen snap-start space-y-12 bg-gray-700 carousel-wrapper flex flex-col justify-center items-center">-->
<!--        <h4 class="text-3xl font-bold md:text-5xl text-purple-500">Galerie</h4>-->
<!--<caroussel />-->
<!--    </section>-->
</template>

<script>
// import caroussel from "../components/Caroussel.vue";
//
//     export default {
//         name: 'portfolioSection',
//         title: 'Loop mode / Infinite loop',
//         components: {caroussel},
//
//     }
</script>

<style lang="scss" scoped>

</style>